import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { type Dispatch, select } from '@swf/core/store';

/**
 * Closes the BetSlip when all the opportunities are removed
 */
const useCloseOnEmpty = () => {
  const dispatch = useDispatch<Dispatch>();
  const hasSelections = useSelector(select.betSlip.hasSelections);
  const isBetReceiptActive = useSelector(select.betSlip.isBetReceiptActive);

  useEffect(() => {
    if (!hasSelections && !isBetReceiptActive) {
      dispatch.betSlip.betSlipOpened(false);
    }
  }, [hasSelections, isBetReceiptActive, dispatch.betSlip]);
};

export default useCloseOnEmpty;
